import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import history from "../../history";
import Modal from "../Modal";
import * as actions from "../../actions";

const RelationDelete = ({
  match: {
    params: { relationid },
  },
}) => {
  const relation = useSelector((state) => state.relations.item);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchRelation(relationid));
  }, []);

  let renderContent = "Are you sure you want to delete this relation?";
  if (relation) {
    renderContent = `Are you sure you want to delete the relation ${relation.name}?`;
  }

  const renderActions = (
    <React.Fragment>
      <button
        onClick={() => dispatch(actions.disableRelation(relationid))}
        className="ui button negative"
      >
        Delete
      </button>
      <button className="ui button" onClick={() => history.goBack()}>
        Cancel
      </button>
    </React.Fragment>
  );

  return (
    <Modal
      title="Delete Relation"
      content={renderContent}
      actions={renderActions}
      onDismiss={() => history.goBack()}
    />
  );
};

export default RelationDelete;
